import React from 'react';
import ImageBanner from 'components/consumer/image-banner';

const ErrorBanner = ({
  heading = 'Whoops! Something went wrong',
  subText = 'The server was unable to complete your request. Please try again later.',
}) => (
  <ImageBanner
    config={{
      styling: {
        value: 'Default',
      },
      imageProps: {
        src:
          'https://joybird2.imgix.net/public_img/static-v1/consumer-home-page/new-home-image.jpg',
        alt: 'BackgroundImage',
        sizes: '100vw',
      },
      textColor: {
        value: 'white',
      },
      heading: {
        content: heading,
        tagName: 'h1',
      },
      subText: {
        content: subText,
      },
      minHeight: {
        value: '65vh',
      },
      showOverlay: {
        value: 0,
      },
      backgroundSize: {
        value: 'cover',
      },
      textOrientation: {
        value: 'Center',
        content: 'Center',
      },
      toggleInputType: {
        ctaLink: {
          style: 'solid-button',
          color: 'white',
          linkTo: '/',
          content: 'Go Home',
        },
        selected: {
          value: 'CTALink',
        },
        ctaButton: {
          type: 'CTA',
          style: 'solid-button',
          color: 'white',
          content: 'Button Content',
          embedCode: {
            value: '',
            enabled: false,
          },
        },
      },
    }}
  />
);

export default ErrorBanner;
